import { choose } from '../../utils/platform';
import FunctionServicesDesktop from './FunctionServices.desktop';
import FunctionServicesMobile from './FunctionServices.mobile';

// Platform chooser: phone (APK or narrow browser) gets the card variant.
export default choose(FunctionServicesDesktop, FunctionServicesMobile);
